export enum GateSide {
  NotSet = 'NotSet',
  Entry = 'Entry',
  Exit = 'Exit'
}

export const GateSides = [GateSide.Entry, GateSide.Exit];
